// Single source of truth for both the live preview and the print file.
export const FONTS = [
  { id: "allura", name: "Allura", family: "Allura", weight: 400, italic: false, script: true },
  { id: "brittany", name: "Brittany (alternative : Mrs Saint Delafield)", family: "Mrs Saint Delafield", weight: 400, italic: false, script: true },
  { id: "greatvibes", name: "Great Vibes", family: "Great Vibes", weight: 400, italic: false, script: true },
  { id: "nautigal", name: "The Nautigal", family: "The Nautigal", weight: 400, italic: false, script: true },
  { id: "seasons", name: "The Seasons (alternative : Cormorant)", family: "Cormorant Garamond", weight: 600, italic: true, script: false },
  { id: "femen", name: "Femen (alternative : Herr Von Muellerhoff)", family: "Herr Von Muellerhoff", weight: 400, italic: false, script: true },
  { id: "tangerine", name: "Tangerine", family: "Tangerine", weight: 400, italic: false, script: true },
  { id: "parfumerie", name: "Parfumerie Script (alternative : Monsieur La Doulaise)", family: "Monsieur La Doulaise", weight: 400, italic: false, script: true },
  { id: "amiri", name: "Amiri", family: "Amiri", weight: 400, italic: true, script: false },
  { id: "citadel", name: "Citadel Script (alternative : Petit Formal)", family: "Petit Formal Script", weight: 400, italic: false, script: true },
  { id: "pinyon", name: "Pinyon Script", family: "Pinyon Script", weight: 400, italic: false, script: true },
  { id: "arefruqaa", name: "Aref Ruqaa (calligraphie arabe)", family: "Aref Ruqaa", weight: 400, italic: false, script: true },
  { id: "playfair", name: "Playfair Display", family: "Playfair Display", weight: 400, italic: true, script: false },
  { id: "cormorant", name: "Cormorant Garamond", family: "Cormorant Garamond", weight: 500, italic: true, script: false },
  { id: "cinzel", name: "Cinzel Decorative", family: "Cinzel Decorative", weight: 400, italic: false, script: false },
  { id: "alexbrush", name: "Alex Brush", family: "Alex Brush", weight: 400, italic: false, script: true },
  { id: "tenor", name: "Tenor Sans", family: "Tenor Sans", weight: 400, italic: false, script: false },
];
export const getFont = (id) => FONTS.find((f) => f.id === id) || FONTS[0];
const fontCss = (f, px, italic) => `${italic && f.italic ? "italic " : ""}${f.weight} ${px}px "${f.family}"`;

export const SIZES = [
  { id: "50x70", label: "50 × 70 cm", w: 50, h: 70, price: 90 },
  { id: "60x80", label: "60 × 80 cm", w: 60, h: 80, price: 110 },
];
export const getSize = (id) => SIZES.find((s) => s.id === id) || SIZES[0];
export const PRINT_DPI = 150;
export const printPixels = (size) => ({
  w: Math.round((size.w / 2.54) * PRINT_DPI),
  h: Math.round((size.h / 2.54) * PRINT_DPI),
});
export const DELIVERY_DELAY = "2 semaines";
export const PANEL_MATERIAL = "Panneau en Forex";
export const NO_SUPPORT_NOTICE = "Le trépied et tout autre support ne sont pas fournis : seul le panneau est livré.";
export const FINAL_NOTICE = "Une fois votre fichier validé, aucune modification ne pourra être apportée : la validation est définitive.";

export const TEXT_FIELDS = [
  { key: "intro", label: "Phrase d'accueil", group: "intro", placeholder: "Ex : Nous avons le plaisir de vous accueillir" },
  { key: "welcome", label: "Phrase de bienvenue", group: "welcome" },
  { key: "names", label: "Prénoms", group: "names" },
  { key: "quote", label: "Citation / phrase", group: "body", multiline: true },
  { key: "reference", label: "Référence de la citation", group: "body" },
  { key: "extra", label: "Phrase supplémentaire", group: "body", placeholder: "Ex : 12 septembre 2026 — Lyon" },
  { key: "number", label: "Date", group: "number", placeholder: "Ex : 12.09.2026" },
];
export const DEFAULT_TEXT_STYLE = { size: 100, dy: 0, align: "center", spacing: 0 };
export const FONT_GROUPS = [
  { key: "intro", label: "Phrase d'accueil" },
  { key: "names", label: "Prénoms" },
  { key: "welcome", label: "Phrase de bienvenue" },
  { key: "body", label: "Citation, référence & phrase libre" },
  { key: "number", label: "Date" },
];
export const BISMILLAH_POSITIONS = [
  { id: "haut", label: "En haut" },
  { id: "bas", label: "En bas" },
];
const BISMILLAH_SRC = "/bismillah.png";
const BISMILLAH_RATIO = 1763 / 404;
export const DIVIDERS = [
  { id: "losange", label: "Losange" },
  { id: "etoile", label: "Étoile" },
  { id: "filet", label: "Filet" },
  { id: "aucun", label: "Aucun" },
];
export const BACKDROPS = [
  { id: "arche", label: "Arche" },
  { id: "cercle", label: "Cercle" },
  { id: "aucun", label: "Aucun" },
];
export const FRAMES = [
  { id: "aucun", label: "Aucun" },
  { id: "simple", label: "Filet simple" },
  { id: "double", label: "Double filet" },
];

const B = (el, h, fs, bleed) => ({ el, h, fs, bleed });
export const PHOTO_KEYS = ["groom", "bride"];
const EMPTY_TEXTS = { intro: "", calligraphy: "", welcome: "", names: "", quote: "", reference: "", extra: "", number: "" };
const BASE_FONTS = { intro: "amiri", calligraphy: "amiri", welcome: "amiri", names: "greatvibes", body: "amiri", number: "amiri" };
const BASE_DEFAULTS = { bgColor: "#FFFFFF", textColor: "#1C1917", ornaments: { frame: "aucun", backdrop: "aucun", divider: "aucun" }, upper: [], italic: [] };

const MARIAGE_LAYOUTS = {
  "photos-bas": {
    label: "Photos en bas",
    blocks: [B("intro", 0.05, 0.04), B("welcome", 0.05, 0.04), B("names", 0.15, 0.105), B("number", 0.06, 0.042), B("quote", 0.06, 0.04), B("reference", 0.045, 0.04), B("extra", 0.04, 0.032), B("photo", 0.56, 0, true)],
  },
  "photos-centre": {
    label: "Photos au centre",
    blocks: [B("intro", 0.05, 0.04), B("welcome", 0.05, 0.04), B("names", 0.14, 0.1), B("number", 0.06, 0.042), B("photo", 0.48), B("quote", 0.07, 0.04), B("reference", 0.045, 0.04), B("extra", 0.045, 0.032)],
  },
};
const FIANCAILLES_LAYOUTS = {
  fiancailles: {
    label: "Photos en bas",
    blocks: [B("intro", 0.08, 0.06), B("welcome", 0.06, 0.055), B("names", 0.13, 0.115), B("quote", 0.07, 0.045), B("reference", 0.04, 0.03), B("extra", 0.04, 0.032), B("number", 0.1, 0.12), B("photo", 0.58, 0, true)],
  },
  "fiancailles-centre": {
    label: "Photos au centre",
    blocks: [B("intro", 0.08, 0.06), B("welcome", 0.06, 0.055), B("names", 0.13, 0.115), B("photo", 0.48), B("quote", 0.07, 0.045), B("reference", 0.04, 0.03), B("extra", 0.04, 0.032), B("number", 0.1, 0.12)],
  },
};
const ANNIV_LAYOUTS = {
  "photo-centre": {
    label: "Photos au centre",
    blocks: [B("intro", 0.06, 0.05), B("welcome", 0.07, 0.055), B("names", 0.14, 0.13), B("photo", 0.46), B("quote", 0.06, 0.034), B("reference", 0.04, 0.03), B("extra", 0.04, 0.032), B("number", 0.14, 0.17)],
  },
};

export const TEMPLATES = [
  {
    id: "bismillah-duo",
    name: "MARIAGE",
    tagline: "Bismillah calligraphiée, prénoms, verset et vos deux photos réunies en bas du tableau.",
    photoLabels: ["Photo du marié", "Photo de la mariée"],
    singleLabel: "Photo du couple",
    photoShort: ["Marié", "Mariée"],
    defaults: {
      ...BASE_DEFAULTS,
      fonts: { ...BASE_FONTS },
      texts: { ...EMPTY_TEXTS, names: "Marwa & Salah", number: "24.09.2026", quote: "« Et Nous vous avons créés par paires »", reference: "S78, V8" },
      bismillah: true,
      photoCount: 2,
      photoCountChoice: true,
    },
    layouts: MARIAGE_LAYOUTS,
  },
  {
    id: "fiancailles",
    name: "FIANÇAILLES",
    tagline: "Phrase d'accueil, « Aux fiançailles de », prénoms calligraphiés, citation et vos deux photos.",
    photoLabels: ["Photo du fiancé", "Photo de la fiancée"],
    photoShort: ["Fiancé", "Fiancée"],
    defaults: {
      ...BASE_DEFAULTS,
      fonts: { ...BASE_FONTS },
      texts: { ...EMPTY_TEXTS, intro: "Nous avons le plaisir de vous accueillir", welcome: "Aux fiançailles de", names: "Safyr & Myriam", quote: "« Le bonheur est la seule chose qui se multiplie lorsqu'on le partage »" },
      photoMode: "bw",
      photoCount: 2,
      photoCountChoice: true,
    },
    layouts: FIANCAILLES_LAYOUTS,
  },
  {
    id: "sur-mesure",
    name: "SUR MESURE",
    tagline: "Anniversaire, naissance, souvenir… Combinez librement toutes les options des modèles Mariage et Fiançailles.",
    photoLabels: ["PHOTO 1", "PHOTO 2"],
    photoShort: ["Photo 1", "Photo 2"],
    defaults: {
      ...BASE_DEFAULTS,
      upper: ["welcome"],
      fonts: { ...BASE_FONTS },
      texts: { ...EMPTY_TEXTS, welcome: "Bienvenue à l'anniversaire de", names: "Sarah", number: "30 ans" },
      photoCount: 1,
      photoCountChoice: true,
    },
    layouts: { ...ANNIV_LAYOUTS, "photos-bas": MARIAGE_LAYOUTS["photos-bas"] },
  },
];
export const templateFields = (tpl) => {
  const used = new Set(Object.values(tpl.layouts).flatMap((l) => l.blocks.map((b) => b.el)));
  return TEXT_FIELDS.filter((f) => used.has(f.key));
};
export const getTemplate = (id) => TEMPLATES.find((t) => t.id === id) || TEMPLATES[0];

export const configFromTemplate = (tpl, prev) => ({
  templateId: tpl.id,
  layoutId: Object.keys(tpl.layouts)[0],
  sizeId: prev?.sizeId || "50x70",
  bgColor: tpl.defaults.bgColor,
  textColor: tpl.defaults.textColor,
  fonts: { ...tpl.defaults.fonts },
  texts: { ...tpl.defaults.texts },
  ornaments: { ...tpl.defaults.ornaments },
  photoMode: tpl.defaults.photoMode || "color",
  photoCount: tpl.defaults.photoCount,
  photoOrder: prev?.photoOrder || "groom-left",
  bismillah: { enabled: !!tpl.defaults.bismillah, position: "haut", color: prev?.bismillah?.color || tpl.defaults.textColor, size: 100, dy: 0 },
  photoScale: { groom: 100, bride: 100 },
  photoDy: 0,
  photoOffset: { groom: { dx: 0, dy: 0 }, bride: { dx: 0, dy: 0 } },
  photoFront: "bride",
  textStyles: Object.fromEntries(TEXT_FIELDS.map((f) => [f.key, { ...DEFAULT_TEXT_STYLE }])),
  italic: Object.fromEntries(TEXT_FIELDS.map((f) => [f.key, (tpl.defaults.italic || []).includes(f.key)])),
});

let fontsPromise;
let bismillahImg = null;
const tintCache = new Map();
const tintedBismillah = (color) => {
  if (!tintCache.has(color)) {
    const c = document.createElement("canvas");
    c.width = bismillahImg.naturalWidth;
    c.height = bismillahImg.naturalHeight;
    const x = c.getContext("2d");
    x.drawImage(bismillahImg, 0, 0);
    x.globalCompositeOperation = "source-in";
    x.fillStyle = color;
    x.fillRect(0, 0, c.width, c.height);
    tintCache.set(color, c);
  }
  return tintCache.get(color);
};

function drawBismillah(ctx, rect, color, W, scale = 1) {
  if (!bismillahImg) return;
  const w = Math.min(W * 0.7, rect.h * 0.95 * BISMILLAH_RATIO) * scale;
  const h = w / BISMILLAH_RATIO;
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(tintedBismillah(color), rect.x + (rect.w - w) / 2, rect.y + (rect.h - h) / 2, w, h);
}
export const ensureFonts = () => {
  if (!fontsPromise) {
    const loads = FONTS.flatMap((f) => [
      document.fonts.load(fontCss(f, 40, false)),
      f.italic ? document.fonts.load(fontCss(f, 40, true)) : null,
    ]).filter(Boolean);
    const img = new Promise((res) => {
      const i = new Image();
      i.onload = () => { bismillahImg = i; res(); };
      i.onerror = () => res();
      i.src = BISMILLAH_SRC;
    });
    fontsPromise = Promise.all([...loads, img]).catch(() => null);
  }
  return fontsPromise;
};

export const hexToRgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

function wrap(ctx, text, maxW) {
  const out = [];
  for (const para of text.split("\n")) {
    let line = "";
    for (const w of para.split(/\s+/).filter(Boolean)) {
      const t = line ? `${line} ${w}` : w;
      if (line && ctx.measureText(t).width > maxW) {
        out.push(line);
        line = w;
      } else line = t;
    }
    if (line) out.push(line);
  }
  return out;
}

function drawText(ctx, text, font, italic, size, rect, maxW, color, align = "center", scale = 1, spacing = 0) {
  const lh = font.script ? 1.2 : 1.3;
  let s = size;
  let lines = [];
  for (let i = 0; i < 40; i++) {
    ctx.font = fontCss(font, s, italic);
    ctx.letterSpacing = `${(s * spacing) / 100}px`;
    lines = wrap(ctx, text, maxW);
    const tooWide = lines.some((l) => ctx.measureText(l).width > maxW);
    if ((!tooWide && lines.length * s * lh <= rect.h * 1.05 * Math.max(1, scale)) || s < 4) break;
    s *= 0.93;
  }
  ctx.fillStyle = color;
  ctx.textAlign = align;
  ctx.textBaseline = "middle";
  const margin = (rect.w - maxW) / 2;
  const cx = align === "left" ? rect.x + margin : align === "right" ? rect.x + rect.w - margin : rect.x + rect.w / 2;
  let y = rect.y + rect.h / 2 - ((lines.length - 1) * s * lh) / 2;
  // Fonts without a true italic face get a deterministic slant (same in preview and print).
  const fakeItalic = italic && !font.italic;
  for (const l of lines) {
    if (fakeItalic) {
      ctx.save();
      ctx.translate(cx, y);
      ctx.transform(1, 0, -0.2, 1, 0, 0);
      ctx.fillText(l, 0, 0);
      ctx.restore();
    } else ctx.fillText(l, cx, y);
    y += s * lh;
  }
  ctx.letterSpacing = "0px";
}

function drawDiamond(ctx, x, y, r) {
  ctx.beginPath();
  ctx.moveTo(x, y - r);
  ctx.lineTo(x + r, y);
  ctx.lineTo(x, y + r);
  ctx.lineTo(x - r, y);
  ctx.closePath();
  ctx.fill();
}

function drawStar(ctx, x, y, r) {
  ctx.beginPath();
  for (let i = 0; i < 8; i++) {
    const a = (i * Math.PI) / 4 - Math.PI / 2;
    const rr = i % 2 === 0 ? r : r * 0.28;
    ctx.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr);
  }
  ctx.closePath();
  ctx.fill();
}

function drawDivider(ctx, style, rect, W, color) {
  if (style === "aucun") return;
  const cx = rect.x + rect.w / 2;
  const cy = rect.y + rect.h / 2;
  const half = W * 0.16;
  const gap = style === "filet" ? 0 : W * 0.025;
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  ctx.lineWidth = Math.max(1, W * 0.0018);
  ctx.beginPath();
  if (style === "filet") {
    ctx.moveTo(cx - half, cy);
    ctx.lineTo(cx + half, cy);
  } else {
    ctx.moveTo(cx - half, cy);
    ctx.lineTo(cx - gap, cy);
    ctx.moveTo(cx + gap, cy);
    ctx.lineTo(cx + half, cy);
  }
  ctx.stroke();
  if (style === "losange") drawDiamond(ctx, cx, cy, W * 0.009);
  if (style === "etoile") drawStar(ctx, cx, cy, W * 0.016);
}

function drawFrame(ctx, style, W, H, color) {
  if (style === "aucun") return;
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  const i1 = W * 0.035;
  ctx.lineWidth = Math.max(1, W * 0.0025);
  ctx.strokeRect(i1, i1, W - 2 * i1, H - 2 * i1);
  if (style === "double") {
    const i2 = W * 0.048;
    ctx.lineWidth = Math.max(1, W * 0.0012);
    ctx.strokeRect(i2, i2, W - 2 * i2, H - 2 * i2);
    for (const [x, y] of [[i1, i1], [W - i1, i1], [i1, H - i1], [W - i1, H - i1]]) drawDiamond(ctx, x, y, W * 0.012);
  }
}

function drawBackdrop(ctx, style, rect, color) {
  if (style === "aucun") return;
  const cx = rect.x + rect.w / 2;
  ctx.fillStyle = hexToRgba(color, 0.14);
  ctx.beginPath();
  if (style === "cercle") {
    const r = Math.min(rect.w * 0.45, rect.h * 0.48);
    ctx.arc(cx, rect.y + rect.h - r * 1.02, r, 0, Math.PI * 2);
  } else {
    const aw = Math.min(rect.w * 0.86, rect.h * 0.9);
    const x0 = cx - aw / 2;
    const top = rect.y + aw / 2;
    ctx.moveTo(x0, rect.y + rect.h);
    ctx.lineTo(x0, top);
    ctx.arc(cx, top, aw / 2, Math.PI, 0);
    ctx.lineTo(x0 + aw, rect.y + rect.h);
    ctx.closePath();
  }
  ctx.fill();
}

function drawSlotPlaceholder(ctx, box, label, color, W) {
  ctx.save();
  ctx.setLineDash([W * 0.012, W * 0.01]);
  ctx.strokeStyle = hexToRgba(color, 0.55);
  ctx.lineWidth = Math.max(1, W * 0.0025);
  ctx.strokeRect(box.x, box.y, box.w, box.h);
  ctx.restore();
  drawText(ctx, label, getFont("cormorant"), false, W * 0.04, { x: box.x, y: box.y + box.h * 0.4, w: box.w, h: box.h * 0.2 }, box.w * 0.85, hexToRgba(color, 0.7));
}

// Two cut-out subjects side by side, bottom-aligned, slight overlap; no transformation besides uniform fit.
function drawPhotos(ctx, imgs, labels, rect, color, W, scales = [1, 1], offs = [{}, {}], H = W, frontIdx = 1) {
  const cx = rect.x + rect.w / 2;
  const ov = rect.w * 0.05;
  const slotW = rect.w / 2 + ov;
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  if (imgs.length === 1) {
    const img = imgs[0];
    if (!img) {
      const w = rect.w * 0.5;
      const h = rect.h * 0.85;
      drawSlotPlaceholder(ctx, { x: cx - w / 2, y: rect.y + rect.h - h, w, h }, labels[0], color, W);
      return;
    }
    const s = Math.min((rect.w * 0.8) / img.width, rect.h / img.height) * scales[0];
    const ox = ((offs[0].dx || 0) / 100) * W;
    const oy = ((offs[0].dy || 0) / 100) * H;
    ctx.drawImage(img, cx - (img.width * s) / 2 + ox, rect.y + rect.h - img.height * s + oy, img.width * s, img.height * s);
    return;
  }
  (frontIdx === 0 ? [1, 0] : [0, 1]).forEach((i) => {
    const img = imgs[i];
    if (!img) {
      const w = slotW * 0.78;
      const h = rect.h * 0.78;
      const x = i === 0 ? cx - W * 0.012 - w : cx + W * 0.012;
      drawSlotPlaceholder(ctx, { x, y: rect.y + rect.h - h, w, h }, labels[i], color, W);
      return;
    }
    const s = Math.min(slotW / img.width, rect.h / img.height) * scales[i];
    const dw = img.width * s;
    const dh = img.height * s;
    const x = (i === 0 ? cx + ov - dw : cx - ov) + ((offs[i].dx || 0) / 100) * W;
    ctx.drawImage(img, x, rect.y + rect.h - dh + ((offs[i].dy || 0) / 100) * H, dw, dh);
  });
}

export function renderPoster(ctx, W, H, cfg, photos = {}) {
  const tpl = getTemplate(cfg.templateId);
  const layout = tpl.layouts[cfg.layoutId] || Object.values(tpl.layouts)[0];
  const color = cfg.textColor;
  ctx.save();
  ctx.clearRect(0, 0, W, H);
  ctx.fillStyle = cfg.bgColor;
  ctx.fillRect(0, 0, W, H);
  drawFrame(ctx, cfg.ornaments.frame, W, H, color);

  const textKeys = TEXT_FIELDS.map((f) => f.key);
  let blocks = layout.blocks.filter((b) => b.el === "photo" || b.el === "divider" || ((textKeys.includes(b.el)) && (cfg.texts[b.el] || "").trim()));
  if (cfg.bismillah?.enabled) {
    const bb = B("bismillah", 0.13);
    blocks = cfg.bismillah.position === "bas" ? [...blocks, bb] : [bb, ...blocks];
  }
  const total = blocks.reduce((a, b) => a + b.h, 0);
  const padY = H * 0.075;
  const inner = H - 2 * padY;
  const maxW = W * (cfg.ornaments.frame === "aucun" ? 0.82 : 0.76);
  const pick = (p) => (p ? (cfg.photoMode === "bw" ? p.bw : p.color) : null);
  const count = cfg.photoCount || 2;
  const order = count === 1 ? [0] : cfg.photoOrder === "bride-left" ? [1, 0] : [0, 1];
  const imgs = order.map((i) => pick(photos[PHOTO_KEYS[i]]));
  const labels = count === 1 ? [tpl.singleLabel || tpl.photoLabels[0]] : order.map((i) => tpl.photoLabels[i]);
  const scales = order.map((i) => (cfg.photoScale?.[PHOTO_KEYS[i]] ?? 100) / 100);
  const offs = order.map((i) => cfg.photoOffset?.[PHOTO_KEYS[i]] || {});
  const frontIdx = Math.max(0, order.indexOf(PHOTO_KEYS.indexOf(cfg.photoFront || "bride")));

  let y = padY;
  blocks.forEach((b, idx) => {
    let h = (b.h / total) * inner;
    if (b.bleed && idx === blocks.length - 1) h += padY;
    const rect = { x: 0, y, w: W, h };
    if (b.el === "bismillah") {
      const dy = ((cfg.bismillah.dy || 0) / 100) * H;
      drawBismillah(ctx, { ...rect, y: rect.y + dy }, cfg.bismillah.color, W, (cfg.bismillah.size ?? 100) / 100);
    } else if (b.el === "photo") {
      const pr = b.bleed ? { x: W * 0.03, y, w: W * 0.94, h } : { x: W * 0.07, y, w: W * 0.86, h };
      pr.y += ((cfg.photoDy || 0) / 100) * H;
      drawBackdrop(ctx, cfg.ornaments.backdrop, pr, color);
      drawPhotos(ctx, imgs, labels, pr, color, W, scales, offs, H, frontIdx);
    } else if (b.el === "divider") {
      drawDivider(ctx, cfg.ornaments.divider, rect, W, color);
    } else {
      const field = TEXT_FIELDS.find((f) => f.key === b.el);
      let text = cfg.texts[b.el];
      if (tpl.defaults.upper.includes(b.el)) text = text.toUpperCase();
      const st = { ...DEFAULT_TEXT_STYLE, ...cfg.textStyles?.[b.el] };
      const sc = st.size / 100;
      const tr = { ...rect, y: rect.y + (st.dy / 100) * H };
      drawText(ctx, text, getFont(cfg.fonts[field.group]), cfg.italic ? !!cfg.italic[b.el] : (tpl.defaults.italic || []).includes(b.el), b.fs * W * sc, tr, maxW, color, st.align, sc, st.spacing || 0);
    }
    y += h;
  });
  ctx.restore();
}

export async function renderToBlob(cfg, photos, { width, height, type = "image/png", quality }) {
  await ensureFonts();
  const c = document.createElement("canvas");
  c.width = width;
  c.height = height;
  renderPoster(c.getContext("2d"), width, height, cfg, photos);
  const blob = await new Promise((res) => c.toBlob(res, type, quality));
  c.width = 0;
  c.height = 0;
  return blob;
}
